'use client'

import { useTranslation } from '@/lib/i18n/useTranslation.client'
import { Form } from '@/ui/form'

type FavoritesListNameInputProps = {
  required?: boolean
}

export function FavoritesListNameInput({ required }: FavoritesListNameInputProps) {
  const { t } = useTranslation(['favoritesListNameInput'])

  const hasInvalidCharacters = (value: string) => {
    // eslint-disable-next-line sonarjs/single-char-in-character-classes
    const forbiddenCharacters = /["`´\\@<>{}()#&!]|[\p{Extended_Pictographic}]/gu

    // eslint-disable-next-line sonarjs/duplicates-in-character-class
    const validation = new RegExp(forbiddenCharacters)

    if (validation.test(value)) {
      return t('favoritesListNameInput:error.invalidCharacters', {
        chars: '"`´\\@<>{}()#&!',
        interpolation: { escapeValue: false },
      })
    }
  }

  return (
    <Form.Input.Text
      name="name"
      label={t('favoritesListNameInput:label')}
      placeholder={t('favoritesListNameInput:placeholder')}
      validate={(value) => hasInvalidCharacters(value)}
      maxLength={70}
      required={required}
    />
  )
}
